export default __webpack_public_path__ + "static/media/scytheshield.68ac914d.png";